import { up_arrow, down_arrow } from './icons'
import m from 'mithril'

const my_table = {

    oninit: vnode => {
        vnode.state.sorting = vnode.attrs.default_sort || false
        vnode.state.sorting_reversed = false //Not reversed
    },
    view: vnode => {
        // console.log(vnode.state)

        let rows = vnode.attrs.rows

        //Warning, mutation occuring
        if (vnode.state.sorting && !vnode.attrs.columns.some(c => c.code == vnode.state.sorting)) {
            vnode.state.sorting = 'title'
            vnode.state.sorting_reversed = false
        }


        if (vnode.state.sorting) {
            let sorting_column = vnode.attrs.columns.find(c => c.code == vnode.state.sorting)
            if (!sorting_column) sorting_column = vnode.attrs.columns.find(c => c.code == vnode.attrs.default_sort)

            rows.sort((a, b) => {

                let comparison = sorting_column.order(a, b, vnode.state.sorting_reversed)
                if (vnode.state.sorting_reversed) comparison = -comparison
                return comparison
            })
        }



        return [

            m('.table_scroller',
                m('table.my_table.style_1',
                    m('tr',
                        vnode.attrs.columns.map((column, i) => m('th',
                            {
                                class: (vnode.state.sorting == column.code ? 'sorting' : '') +
                                    (vnode.state.sorting_reversed == column.code ? 'sorting_reversed' : '')
                                ,
                                onclick: () => {
                                    // if (column.order) {
                                    //     if (!vnode.state.sorting || vnode.state.sorting != column.code) {
                                    //         vnode.state.sorting = column.code
                                    //         vnode.state.sorting_reversed = false
                                    //     }
                                    //     else {
                                    //         vnode.state.sorting_reversed = !vnode.state.sorting_reversed
                                    //     }
                                    // }
                                }
                            },
                            m(column.header),
                            vnode.state.sorting == column.code && !vnode.state.sorting_reversed ? m(up_arrow) : [],
                            vnode.state.sorting == column.code && vnode.state.sorting_reversed ? m(down_arrow) : [],
                        )
                        )
                    ),
                    vnode.attrs.skeleton_rows ?
                        [...Array(10)]
                            .map(skeleton_row => [
                                m('tr',
                                    vnode.attrs.columns.map(column => [
                                        m('td',
                                            {
                                            },
                                            m('.word_shimmer', '-')
                                        )
                                    ])
                                )
                            ])
                        :
                        rows
                            .slice(0, vnode.attrs.max_rows || rows.length)
                            .map(row => m(row_component, {
                                row: row, columns: vnode.attrs.columns,
                                key: row.code,
                                onload: vnode.attrs.onload
                            }))
                )
            ),

            (vnode.attrs.max_rows && vnode.attrs.max_rows < rows.length) ? m(max_rows_ellipses) : []
        ]
    }
}

const max_rows_ellipses = {
    view: vnode => [
        m('.max_rows_ellipses', [...Array(3)].map(_ => m('.ellipse')))
    ]
}

const row_component = {
    oninit: vnode => {
        if (vnode.attrs.onload) {
            vnode.attrs.onload(vnode.attrs.row)
        }
    },
    view: vnode => {
        return [

            m('tr',
                vnode.attrs.columns.map(column => [
                    m('td',
                        {
                            class: column.class ? column.class(vnode.attrs.row) : ''
                        },
                        m(column.content, { row: vnode.attrs.row })
                    )
                ])
            )
        ]
    }
}

export default my_table